import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2025 semantics GmbH
//  Date      : $Date: 2025-11-27 00:23:14 +0100 (Thu, 27 Nov 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 158683 $
//  Purpose   : generic menu operations for tree nodes
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Checkbox } from 'semantic-ui-react';
// ---Framework imports
import { dict } from 'ldash';
import { Actions, Sel } from 'uix/registries';
import log from 'uix/logging';
import { useState, useActions } from 'uix/hooks';
import { DebugFeature, XMenu } from 'uix/components';
import { TreeNode } from 'uix/types/components';
// ---Local imports
// ---Exports
export const NodeDelete = {
    nodeMenuItem: ({ node, i18n })=>{
        let deleteTreeRecords = useActions(Actions.deleteTreeRecords);
        let [erase, setErase] = useState(false);
        let confirmation = {
            size: 'small',
            content: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("b", {
                        children: "Delete "
                    }),
                    " ",
                    /*#__PURE__*/ _jsx(TreeNode, {
                        node: node
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("b", {
                        children: "?"
                    }),
                    /*#__PURE__*/ _jsxs(DebugFeature, {
                        children: [
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(Checkbox, {
                                label: "Erase",
                                checked: erase,
                                onChange: ()=>setErase(!erase)
                            })
                        ]
                    })
                ]
            })
        };
        return /*#__PURE__*/ _jsx(XMenu.Item, {
            disabled: !!node.slimlink,
            icon: "trash",
            title: "Delete",
            onClick: ()=>deleteTreeRecords({
                    otids: [
                        node.otid
                    ],
                    erase
                }),
            confirm: confirmation
        });
    },
    acl: 'g:admin',
    enabled: ({ node })=>![
            10,
            7
        ].includes(node.datatype)
};
